import React, { useEffect, useMemo, useState } from "react"
import { ProfilePageContext } from "layouts/profile/context/useProfileContext.ts"
import { useMmsService } from "services/mms/context/MmsServiceContext.tsx"
import { Organization, UserProfileItem } from "types/profile"
import { PermIdentity, MailOutline } from "@mui/icons-material"
import TranslateIcon from "@mui/icons-material/Translate"
import LockOutlinedIcon from "@mui/icons-material/LockOutlined"
import PersonPinCircleOutlinedIcon from "@mui/icons-material/PersonPinCircleOutlined"
import { OrganizationTag } from "layouts/profile/componant/OrganizationTag.tsx"
import { UserInfo } from "types/user"

export const ProfilePageProvider = ({
    children,
}: {
    children: React.ReactNode
}) => {
    const mmsService = useMmsService()
    const profileService = mmsService.getProfileService()
    const organizationService = mmsService.getOrganizationService()
    const {
        data: getSelfProfile,
        sendRequest: fetchSelfProfile,
        isLoading,
    } = profileService.useGetSelfProfile()
    const {
        data: getOrganization,
        sendRequest: fetchOrganization,
        success: organizationSuccess,
        isLoading: organizationLoading,
    } = organizationService.useGetOrganization({
        include_children: true,
        depth: 3,
    })

    const [clickOnPassword, setClickOnPassword] = useState(false)
    const [isPasswordPopinOpen, setIsPasswordPopinOpen] = useState(false)
    const [selfProfile, setSelfProfile] = useState<UserInfo | null>(null)

    const [organization, setOrganization] = useState<Organization | null>(null)

    useEffect(() => {
        fetchSelfProfile()
        fetchOrganization()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])


    useEffect(() => {
        if (getOrganization) {
            setOrganization(getOrganization as Organization)
        }
    }, [getOrganization])
    useEffect(() => {
        if (getSelfProfile) {
            setSelfProfile(getSelfProfile as UserInfo)
        }
    }, [getSelfProfile])

    const modifyEmail = () => {}
    const modifyPassword = () => {
        setClickOnPassword((prev) => !prev)
    }
    const modifyLanguage = () => {}

    // Use real organization from backend instead of mocked tree
    // (no local mock entity; rely on `organization` state normalized from backend)

    const userProfile: UserProfileItem[] = useMemo(() => {
        return [
            {
                icon: <PermIdentity sx={{ marginRight: "12px", color: "#39C610" }} />,
                label: "Nom",
                value: selfProfile ? selfProfile.username : "",
                hasButton: false,
            },
            {
                icon: <MailOutline sx={{ marginRight: "12px", color: "#39C610" }} />,
                label: "Email",
                value: selfProfile ? selfProfile.email : "",
                hasButton: false,
                eventClick: modifyEmail,
            },
            {
                icon: (
                    <LockOutlinedIcon sx={{ marginRight: "12px", color: "#39C610" }} />
                ),
                label: "Mot de passe",
                value: clickOnPassword ? "" : "*****************",
                description:
                    "Nous vous enverrons les instructions pour réinitialiser votre mot de passe directement sur votre adresse e-mail.",
                hasButton: true,
                eventClick: modifyPassword,
                isPasswordSection: true,
            },
            {
                icon: <TranslateIcon sx={{ marginRight: "12px", color: "#39C610" }} />,
                label: "Langue",
                value: "Français",
                hasButton: false,
                eventClick: modifyLanguage,
            },
            {
                icon: (
                    <PersonPinCircleOutlinedIcon
                        sx={{ marginRight: "12px", color: "#39C610" }}
                    />
                ),
                label: "Entité",
                value: organization ? (
                    <OrganizationTag CurrentOrganization={organization} mode="chip" />
                ) : (
                    ""
                ),
                hasButton: false,
            },
        ]
    }, [selfProfile, clickOnPassword, organization])

    return (
        <ProfilePageContext.Provider
            value={{
                selfProfile,
                isLoading,
                organization,
                userProfile,
                clickOnPassword,
                isPasswordPopinOpen,
                modifyEmail,
                modifyPassword,
                modifyLanguage,
                setIsPasswordPopinOpen,
                organizationSuccess,
                organizationLoading,
            }}
        >
            {children}
        </ProfilePageContext.Provider>
    )
}
